<!-- text-formatting-input.component.html -->
<div class="NgxEditor__Wrapper input" [ngClass]="[inputHeight, isDisabled ? 'disabled' : '']">
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
  <ngx-editor 
    [editor]="editor"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [placeholder]="placeholder"
    [disabled]="isDisabled">
  </ngx-editor>
</div>
